<template lang="pug">
.analysisUserDetail
  #graphs
    h1 {{ $t('Analysis.User.title01') }}
    .events
      .profile
        img(:src="isEmptyImg(customer.image)" class="thumb")
        span.name {{ customer.nickname }}
        span.gender(:class="customer.gender") {{ makeGender() }}
        span.age {{ makeAge() }}
      Usage.graph(:width="550", :eventCounts="customer.event_counts" ref="graph")
    .legend(v-html="legend")

  #eventList
    h1 {{ $t('Analysis.User.title02') }}
    EventList


</template>

<script>
import Customer from '@/utils/customer'
import Usage from './Usage'
import EventList from './EventList'
import API from '@/api/analytics'

export default {
  data() {
    return {
      customer: {
        event_counts: { }
      },
      legend: null
    }
  },
  components: { Usage, EventList },
  mixins: [Customer],
  methods: {
    makeAge: function(){
      return this.showAge(this.customer.age);
    },
    isEmptyImg: function(url){
      return url != null ? url : require("@/assets/default.svg");
    },
    makeGender: function(){
      return this.showGender(this.customer.gender);
    },
    setLastBreadcrumb: function() {
      this.$store.commit('setLastBreadcrumb', this.customer.nickname || '')
    },
    getCustomerData() {
      const that = this;
      API.getCustomerDetails({ id: this.$route.params.id }).then(function(response) {
        if (response && response.customer_details) {
          that.customer = response.customer_details;
        } else {
          that.customer = { };
        }
      }).then(function(){
        let labels = that.$refs.graph.chartData.labels
        let colors = that.$refs.graph.chartData.datasets[0].backgroundColor

        var html = '<ul>'
        let list = labels.map(function(label, index){
          return '<li><span class="mark" style="background-color:'+colors[index]+'"></span>'+label+'</li>'
        })
        html += list.join('')
        html += '</ul>'
        that.legend = html
      });
    }
  },
  mounted() {
    this.getCustomerData();
  },
  watch: {
    customer() {
      this.setLastBreadcrumb();
      this.TitleModule_setPageTitle(this.customer.nickname);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.analysisUserDetail {
  background: #FFF;
  margin: 30px 40px;
  border: 1px solid $border;
  border-radius: 5px;
  position: relative;

  .graph {
    position: relative;
    z-index: 1;
  }

  .profile {
    position: absolute;
    width: 200px;
    text-align: center;

    img.thumb {
      margin: 0 0 5px 0;
    }

    span.name {
      display: block;
      font-size: 14px;
      margin-bottom: 0;
    }

    span.gender {
      display: inline-block;
      background: #999;
      padding: 2px 10px;
      font-size: 12px;
      font-weight: bold;
      color: #FFF;
      border-radius: 16px;
      margin-right: 5px;
      &.male { background: #3A5998; }
      &.female { background: #1D262D; }
    }

    span.age {
      font-size: 12px;
    }
  }

  #graphs, #eventList {
    padding: 10px 40px 30px 40px;

    h1 {
      font-size: 16px;
      font-weight: normal;
      margin-bottom: 10px;
    }

    .events {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }

    .legend ::v-deep {
      display: block;
      width: 200px;
      margin: 0 auto;
      text-align: left;
      font-size: 12px;
      ul {
        list-style: none;
        li {
          line-height: 1.5;
          span.mark {
            display: inline-block;
            width: 40px;
            height: 13px;
            margin-right: 5px;
            border-radius: 3px;
            vertical-align: middle;
          }
        }
      }
    }
  }

  #eventList {
    border-top: 1px solid $border;
  }

}

</style>
